import type { FormattedText } from '@mntn-dev/utility-types'

export const generateFormattedTextJson = (text: string): FormattedText => {
  if (text.length === 0) {
    return {
      type: 'doc',
      content: [{ type: 'paragraph' }],
    }
  }

  return {
    type: 'doc',
    content: [{ type: 'paragraph', content: [{ type: 'text', text }] }],
  }
}

export const generateFormattedText = (text: string): string => {
  return JSON.stringify(generateFormattedTextJson(text))
}
